import QueueApi from '../../../services/api/QueueApi';

/* Service class used to perform api calls for queueing */
class QueueService {
    constructor() {
        this.api = QueueApi.create();
    }

    /**
     * Retrieves the summary queue data for this user
     */
    async getQueueSummary(associateId) {
        let summary = null;
        try {
            let response = await this.api.getQueueSummary(associateId);
            if (response) {
                if (response.status === 200) {
                    summary = response.data
                } else if (response.status === 403 || response.status === 400) {
                    return { error_code: response.status }
                }
            }
        } catch (ex) {
            console.log(ex)
        }

        return summary
    }

    /**
     * Retrieves the summary of unassigned queue data
     */
    async getUnassignedQueueSummary() {
        let summary = null
        try {
            let response = await this.api.getUnassignedQueueSummary();
            if (response && response.status === 200) {
                summary = response.data
            }
        } catch (ex) {
            console.log(ex)
        }

        return summary
    }

    /**
     * Retrieves the selected page of tickets with the specified sort options
     * @param {any} sort
     * @param {any} reversed
     * @param {any} limit
     * @param {any} offset
     */
    async getQueueTickets(associateId, sort, reversed, limit, offset) {
        let queueResponse = null
        try {
            let response = await this.api.getQueueTickets(associateId, sort, reversed, limit, offset);
            if (response && response.status === 200) {
                queueResponse = response.data
            }
        } catch (ex) {
            console.log(ex)
        }

        return queueResponse
    }

    /**
    * Retrieves the selected page of tickets with the specified sort options
    * @param { any } sort
    * @param { any } reversed
    * @param { any } limit
    * @param { any } offset
    */
    async getUnassignedQueueTickets(sort, reversed, limit, offset) {
        let queueResponse = null
        try {
            let response = await this.api.getUnassignedQueueTickets(sort, reversed, limit, offset);
            if (response && response.status === 200) {
                queueResponse = response.data
            }
        } catch (ex) {
            console.log(ex)
        }

        return queueResponse
    }


    /**
     * Retrieves the list of tickets for an associate Id and supports OData Filtering
     * @param { any } associateId
     */
    async getTicketsForAssociate(associateId, query) {
        let queueResponse = null
        try {
            let response = await this.api.getTicketsForAssociate(associateId, query);
            if (response && response.status === 200) {
                queueResponse = response.data
            }
        } catch (ex) {
            console.log(ex)
        }

        return queueResponse
    }

}

const queueService = new QueueService();
export default queueService;